var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blueprint-wrapper',[_c('blueprint-header',[_c('app-header-base')],1),_c('blueprint-content',[_c('router-view')],1),_c('blueprint-footer',[_c('footer-lower')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }